module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.ttf?c227050c1152e4b46f1717820c907b9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = 967
// module chunks = 1